import { IonCol, IonGrid, IonRow, IonText } from '@ionic/react';
import { FormattedMessage } from 'react-intl';

import styles from '@components/NavigatingJourneyPage.module.css';
import AppPage from '@components/pageTypes/AppPage';
import StageImage from '@components/StageImage';
import HugeText from '@components/text/HugeText';
import PageTitle from '@components/text/PageTitle';
import SectionTitle from '@components/text/SectionTitle';
import { StageEnum } from '@typing/Generated';

const NavigatingJourneyPage = () => (
  <AppPage>
    <PageTitle imageName="peopleCoffeeLight" titleKey="pages.navigatingCarePlan.title" />
    <div className={styles.sizeControl}>
      <SectionTitle data-test="navigating-heading">
        <FormattedMessage id="pages.navigatingCarePlan.subTitle" />
      </SectionTitle>
      <p>
        <IonText className="ion-padding-vertical">
          <FormattedMessage id="pages.navigatingCarePlan.p1" />
        </IonText>
      </p>
      <p>
        <IonText className="ion-padding-vertical">
          <FormattedMessage id="pages.navigatingCarePlan.p2" />
        </IonText>
      </p>

      <IonGrid className="ion-padding-top">
        <IonRow className="ion-padding">
          <IonCol className="ion-padding-end" size="4">
            <StageImage stage={StageEnum.independent} />
          </IonCol>
          <IonCol className="ion-padding-start" size="8">
            <HugeText>
              <FormattedMessage id="pages.navigatingCarePlan.independent.title" />
            </HugeText>
            <p>
              <IonText>
                <FormattedMessage id="pages.navigatingCarePlan.independent.p1" />
              </IonText>
            </p>
            <p>
              <IonText>
                <FormattedMessage id="pages.navigatingCarePlan.independent.p2" />
              </IonText>
            </p>
          </IonCol>
        </IonRow>
        <IonRow className="ion-padding">
          <IonCol className="ion-padding" size="4">
            <StageImage stage={StageEnum.interdependent} />
          </IonCol>
          <IonCol className="ion-padding-start" size="8">
            <HugeText>
              <FormattedMessage id="pages.navigatingCarePlan.interdependent.title" />
            </HugeText>
            <p>
              <IonText>
                <FormattedMessage id="pages.navigatingCarePlan.interdependent.p1" />
              </IonText>
            </p>
            <p>
              <IonText>
                <FormattedMessage id="pages.navigatingCarePlan.interdependent.p2" />
              </IonText>
            </p>
          </IonCol>
        </IonRow>
        <IonRow className="ion-padding">
          <IonCol className="ion-padding" size="4">
            <StageImage stage={StageEnum.dependent} />
          </IonCol>
          <IonCol className="ion-padding-start" size="8">
            <HugeText>
              <FormattedMessage id="pages.navigatingCarePlan.dependent.title" />
            </HugeText>
            <p>
              <IonText>
                <FormattedMessage id="pages.navigatingCarePlan.dependent.p1" />
              </IonText>
            </p>
            <p>
              <IonText>
                <FormattedMessage id="pages.navigatingCarePlan.dependent.p2" />
              </IonText>
            </p>
          </IonCol>
        </IonRow>
        <IonRow className="ion-padding">
          <IonCol className="ion-padding" size="4">
            <StageImage stage={StageEnum.crisis} />
          </IonCol>
          <IonCol className="ion-padding-start" size="8">
            <HugeText>
              <FormattedMessage id="pages.navigatingCarePlan.crisis.title" />
            </HugeText>
            <p>
              <IonText>
                <FormattedMessage id="pages.navigatingCarePlan.crisis.p1" />
              </IonText>
            </p>
            <p>
              <IonText>
                <FormattedMessage id="pages.navigatingCarePlan.crisis.p2" />
              </IonText>
            </p>
          </IonCol>
        </IonRow>
        <IonRow className="ion-padding">
          <IonCol className="ion-padding" size="4">
            <StageImage stage={StageEnum.end_of_life} />
          </IonCol>
          <IonCol className="ion-padding-start" size="8">
            <HugeText>
              <FormattedMessage id="pages.navigatingCarePlan.end_of_life.title" />
            </HugeText>
            <p>
              <IonText>
                <FormattedMessage id="pages.navigatingCarePlan.end_of_life.p1" />
              </IonText>
            </p>
            <p>
              <IonText>
                <FormattedMessage id="pages.navigatingCarePlan.end_of_life.p2" />
              </IonText>
            </p>
          </IonCol>
        </IonRow>
        <IonRow className="ion-padding">
          <IonCol className="ion-padding" size="4">
            <StageImage stage={StageEnum.bereavement} />
          </IonCol>
          <IonCol className="ion-padding-start" size="8">
            <HugeText>
              <FormattedMessage id="pages.navigatingCarePlan.bereavement.title" />
            </HugeText>
            <p>
              <IonText>
                <FormattedMessage id="pages.navigatingCarePlan.bereavement.p1" />
              </IonText>
            </p>
            <p>
              <IonText>
                <FormattedMessage id="pages.navigatingCarePlan.bereavement.p2" />
              </IonText>
            </p>
          </IonCol>
        </IonRow>
      </IonGrid>
    </div>
  </AppPage>
);

export default NavigatingJourneyPage;
